<template>
  <footer class="footer-nav">
    <!-- 顶部导航链接 -->
    <div class="footer-top">
      <div class="footer-container">
        <div class="footer-links">
          <div class="dropdown-group">
            <div class="dropdown" v-for="(group, index) in linkGroups" :key="index">
              <button class="dropdown-toggle" @click="toggleDropdown(index)">
                {{ group.title }}
                <span class="dropdown-arrow" :class="{ 'active': activeDropdown === index }">▼</span>
              </button>
              <div class="dropdown-menu" :class="{ 'show': activeDropdown === index }">
                <a v-for="link in group.links" :key="link.url" :href="link.url" class="dropdown-item" target="_blank">
                  {{ link.text }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 虚线分隔 -->
    <div class="footer-divider"></div>
    
    <!-- 主要内容区域 -->
    <div class="footer-main">
      <div class="footer-container">
        <!-- 联系信息和版权 -->
        <div class="footer-info">
          <div class="contact-info">
            <p>学校地址:中国辽宁省鞍山市高新区鞍千路300号</p>
            <p>联系电话:0412-5227700</p>
            <p>传真号码:0412-5227755</p>
            <p>电子邮箱:f711210@163.com</p>
          </div>
          <div class="copyright-info">
            <p>版权所有©鞍山市第一中学信息中心 2006-2018</p>
            <p>网站备案:辽ICP07014503号</p>
            <p>技术支持：辽宁京昀技术软件有限公司</p>
          </div>
        </div>
        
        <!-- 底部区域：Logo、校训、二维码 -->
        <div class="footer-bottom">
          <!-- 学校Logo -->
          <div class="school-logo">
            <img src="@/assets/img/foot-logo.png" alt="">
          </div>
          
       
          
          <!-- 二维码区域 -->
          <div class="qr-codes">
            <div class="qr-item">
              <img src="@/assets/img/wb.png" alt="">
            
              <p class="qr-label">关注学校微博</p>
            </div>
            <div class="qr-item">
             
              <img src="@/assets/img/wx.jpg" alt="">
             
              <p class="qr-label">关注学校微信</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterNav',
  data() {
    return {
      activeDropdown: null,
      linkGroups: [
        {
          title: '教育资源网站',
          links: [
            { text: '国家智慧教育平台', url: 'https://basic.smartedu.cn/' },
            { text: '学科网', url: 'https://sso.zxxk.com/login' },
            { text: '辽宁教育资源平台', url: 'https://www.lnjyy.cn:20030/cms-portal/ysyykResource.html' },
            { text: '鞍山资源平台', url: 'http://www.aseduzy.com/index.do' }
          ]
        },
        {
          title: '教育研训部门',
          links: [
            { text: '智能研修平台', url: 'https://eduncet.zonekey.com.cn/edu_cloud/login/user' },
            { text: '教师管理系统', url: 'https://jsxt.lnen.cn/' },
            { text: '辽宁省教育厅', url: 'http://jyt.ln.gov.cn/' },
            { text: '鞍山市教育局', url: 'http://www.asedu.cn/' }
          ]
        },
        {
          title: '友好学校',
          links: [
            { text: '清华大学附属中学', url: 'https://www.qhfz.edu.cn/' },
            { text: '北京四中', url: 'https://www.bhsf.cn/' },
            { text: '上海中学', url: 'https://www.shs.cn/' },
            { text: '深圳中学', url: 'https://www.shenzhong.net/' }
          ]
        },
        {
          title: '其他链接',
          links: [
            { text: '校园电视台', url: 'https://www.youku.com/profile/index/' },
            { text: '数字图书馆', url: 'http://www.aslibrary.com/' },
            { text: '学校微博', url: '#' },
            { text: '学校微信', url: '#' }
          ]
        }
      ]
    }
  },
  methods: {
    toggleDropdown(index) {
      this.activeDropdown = this.activeDropdown === index ? null : index;
    }
  }
}
</script>

<style scoped>
.footer-nav {
  background: url('~@/assets/img/foot-bg.png') no-repeat;
  background-size: 100% 100%;
  color: white;
  position: relative;
  overflow: hidden;
}

/* 樱花背景装饰 */
.footer-nav::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 20%, rgba(255, 182, 193, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 30%, rgba(255, 192, 203, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 40% 70%, rgba(255, 182, 193, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 70% 80%, rgba(255, 192, 203, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

/* 顶部导航链接 */
.footer-top {
  padding: 20px 0;
  position: relative;
  z-index: 10;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.dropdown-group {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.dropdown {
  position: relative;
}

.dropdown-toggle {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-content: space-between;
}

.dropdown-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.dropdown-arrow {
  transition: transform 0.3s ease;
  font-size: 12px;
}

.dropdown-arrow.active {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  min-width: 200px;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  color: white;
  text-decoration: none;
  padding: 10px 15px;
  font-size: 13px;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
  padding-left: 20px;
}

/* 虚线分隔 */
.footer-divider {
  height: 1px;
  background: repeating-linear-gradient(
    to right,
    transparent,
    transparent 10px,
    rgba(255, 255, 255, 0.3) 10px,
    rgba(255, 255, 255, 0.3) 20px
  );
  margin: 0 20px;
}

/* 主要内容区域 */
.footer-main {
  padding: 30px 0 40px;
}

.footer-info {
  margin-bottom: 20px;
}

.contact-info {
  display: flex;
  margin-bottom: 10px;
}

.copyright-info {
  display: flex;
}
.contact-info p,
.copyright-info p {
  margin: 4px 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}

/* 底部区域 */
.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

/* 学校Logo */
.school-logo {
  flex-shrink: 0;
}

.logo-circle {
  position: relative;
  width: 80px;
  height: 80px;
}

.logo-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.logo-text {
  color: #1a237e;
  font-size: 24px;
  font-weight: bold;
}

.logo-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
  border: 3px solid white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.ring-text {
  font-size: 8px;
  font-weight: bold;
  text-align: center;
  line-height: 1.1;
}

.ring-year {
  font-size: 10px;
  font-weight: bold;
  margin-top: 2px;
}

/* 校训 */
.school-motto {
  flex: 1;
  text-align: center;
}

.motto-text {
  font-size: 28px;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;
}

/* 二维码区域 */
.qr-codes {
  display: flex;
  gap: 20px;
  flex-shrink: 0;
}

.qr-item {
  text-align: center;
  img{
    display: block;
    width: 90px;
    height: 90px;
  }
}


.qr-label {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-links {
    gap: 15px;
  }
  
  .dropdown-group {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  
  .dropdown-toggle {
    min-width: 200px;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .school-motto {
    order: -1;
  }
  
  .motto-text {
    font-size: 24px;
  }
  
  .qr-codes {
    justify-content: center;
  }
  
  .contact-info p,
  .copyright-info p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 15px;
  }
  
  .footer-main {
    padding: 20px 0 30px;
  }
  
  .motto-text {
    font-size: 20px;
    letter-spacing: 1px;
  }
  
  .logo-circle {
    width: 60px;
    height: 60px;
  }
  
  .logo-inner {
    width: 40px;
    height: 40px;
  }
  
  .logo-text {
    font-size: 20px;
  }
  
  .logo-ring {
    width: 60px;
    height: 60px;
  }
  
  .ring-text {
    font-size: 6px;
  }
  
  .ring-year {
    font-size: 8px;
  }
}
</style>

